import type { MembershipRole } from '@/hooks/admin/useAdminCustomerUsers';

/**
 * Canonical membership-role vocabulary for the admin Users surfaces.
 *
 * The DB migration 20260614000002_roles_to_admin promoted every legacy
 * 'location_manager' to 'admin' and changed the column default to 'member'.
 * New selections offer Member / Admin / Accounts payable. Legacy values still
 * render readably via roleLabel().
 */
export const ROLE_OPTIONS: ReadonlyArray<{ value: MembershipRole; label: string }> = [
  { value: 'member', label: 'Member' },
  { value: 'admin', label: 'Admin (customer side)' },
  { value: 'ap', label: 'Accounts payable' },
];

export function roleLabel(role: string): string {
  switch (role) {
    case 'admin':
    case 'owner':
      return 'Admin';
    case 'member':
      return 'Member';
    case 'ap':
      return 'Accounts payable';
    case 'location_manager':
      return 'Location manager'; // legacy — kept readable until next save
    default:
      return role;
  }
}
